import { action, observable, computed } from "mobx";

const MAX_LOG_ENTRIES = 40;

class DebugStore {
    @observable debug = false;
    @observable entries: any[] = [];
    @observable showConsole = false;

    @action pushMessage(message: string, ...optionalParams: any[]) {
        // Delete oldes entry
        const newEntries = this.entries.length >= MAX_LOG_ENTRIES ? this.entries.slice(0, MAX_LOG_ENTRIES - 1) : this.entries;

        // Add new entry at front
        newEntries.unshift({ message, optionalParams });

        // Trigger rerender
        this.entries = newEntries;
    }
}

export const debugStore = new DebugStore();



// WEBPACK FOOTER //
// ./src/stores/DebugStore.ts